import cn from "classnames";
import React from "react";
import Template from "./template";

export default class Checkbox extends Template {
    renderLabel = () => {
        const { label, labelWrapper, required, fieldBeforeLabel } = this.props;
        const value = this.props.value === null || this.props.value === undefined ? false : this.props.value;
        if (label) {
            const cnames = cn({
                "col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left": !labelWrapper,
                "field-wrap__label--required": required,
                checkbox__text: fieldBeforeLabel,
                [labelWrapper]: !!labelWrapper,
            });
            const labelProps = {
                className: cnames,
                ...(fieldBeforeLabel ? { onClick: this.setValue.bind(this, !value) } : {}),
            };
            return <label {...labelProps}>{label}</label>;
        }
        return null;
    };

    setValue = (newValue) => {
        const { inputProps, onChange, value, disabled } = this.props;
        if (onChange) {
            if (inputProps.disabled || disabled) {
                return onChange({ name: inputProps.name, value });
            }
            this.validate(newValue);
            return onChange({ name: inputProps.name, value: newValue });
        }
    };

    renderField = () => {
        const { inputProps, disabled, checkboxWrapCname } = this.props;
        const value = this.props.value === null || this.props.value === undefined ? false : this.props.value;

        const checkboxCname = cn("checkbox", {
            "checkbox--checked": value,
            "checkbox--disabled": disabled,
        });
        return (
            <div className={checkboxWrapCname || "my-2"}>
                <span className={checkboxCname} onClick={this.setValue.bind(this, !value)} name={inputProps.name} />
            </div>
        );
    };
}
